module.exports = __webpack_public_path__ + "static/pic-3-55a98b1c9c710f0ba9b51fc67876c24b.png";